import React, { useState, useEffect, useMemo } from 'react';
import { connect } from "react-redux"
import withStyles from '@material-ui/core/styles/withStyles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Grid, Typography, Backdrop, CircularProgress } from '@material-ui/core';
import Modal from 'antd/es/modal';
import { useHistory } from 'react-router-dom';
import { FormatNumberMXN, formatDate } from "../../common/Utils";
const MuiAccordion = withStyles({
    root: {
        "&$expanded": {
            margin: "auto",
            border: '1px solid rgba(125, 155, 193)',
        }
    },
    expanded: {}
})(Accordion);
const OrderDetailAdvance = ({ classes, advancePymtRequestId, t, ...props }) => {
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [showComponentGeneral, setShowComponentGeneral] = useState(true);
    const [data, setData] = useState({});
    const history = useHistory();
    useEffect(() => {
            setData({});
            handleOpenBackdrop();
            props.actions.GetAdvanceDetail(props.userLanguage, props.userToken, advancePymtRequestId, onError, onSuccess);
    }, [advancePymtRequestId]) 

    const onError = (err) => 
    {
        handleCloseBackdrop();
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    return;
                case 403:
                    history.push('/forbidden')
                    return;
                default:
                    break
            }
        }
        Modal.error({
            title: 'Error',
            content: t('commonMessages.alert500')
        })
    }
    const onSuccess = (response) => 
    {
        handleCloseBackdrop();
        setData(response);
    }
    const toggleAcordionGeneral = () => {
        setShowComponentGeneral((prev) => !prev);
    };
    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    };
    return (
        <>
            <Backdrop className={classes.backdrop} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <MuiAccordion defaultExpanded={true} border={4} expanded={showComponentGeneral}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel5a-content"
                    id="panel5a-header"
                    style={{ backgroundColor: "#789AC1", minHeight: "37px", height: "37px" }}
                    IconButtonProps={{ onClick:toggleAcordionGeneral}} >
                    <Typography variant="body2" style={{ color: "#fff" }}>{t('AdvanceDetail.Title')}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{paddingLeft: '40px'}}>
                    <Grid container>
                        <Grid container item xs={12}>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" ><b>{t(`AdvanceDetail.IdAdvance`)}</b></Typography>
                                <Typography variant="body2">{data.advancePymtRequestId}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" ><b>{t(`AdvanceDetail.AdvanceDate`)}</b></Typography>
                                <Typography variant="body2">{data.pymtRequestCreationDt ? formatDate(data.pymtRequestCreationDt): ''}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" ><b>{t(`AdvanceDetail.AdvanceTotal`)}</b></Typography>
                                <Typography variant="body2">{isNaN(data.advancePymtRequestAmt) ? '' : FormatNumberMXN(data.advancePymtRequestAmt)}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}> 
                                <Typography variant="body2" ><b>{t(`AdvanceDetail.Currency`)}</b></Typography>
                                <Typography variant="body2">{data.currencyCode}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12} style={{marginTop: '30px', marginBottom: '70px'}}>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" ><b>{t(`AdvanceDetail.AdvanceStatus`)}</b></Typography>
                                <Typography variant="body2">{data.advanceStatus}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" style={{background: '#DCEAF7', color: '#7A9BC2', padding: '5px 10px'}}><b>{t(`AdvanceDetail.TotalVerified`)}</b></Typography>
                                <Typography variant="body2" style={{padding: '5px 10px'}}>{isNaN(data.totalVerified) ? '' : FormatNumberMXN(data.totalVerified)}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" style={{background: '#DCEAF7', color: '#7A9BC2', padding: '5px 10px'}}><b>{t(`AdvanceDetail.TotalInProcess`)}</b></Typography>
                                <Typography variant="body2" style={{padding: '5px 10px'}}>{isNaN(data.totalInProcess) ? '' : FormatNumberMXN(data.totalInProcess)}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}> 
                                <Typography variant="body2" style={{background: '#DCEAF7', color: '#7A9BC2', padding: '5px 10px'}}><b>{t(`AdvanceDetail.TotalRemainder`)}</b></Typography>
                                <Typography variant="body2" style={{padding: '5px 10px'}}>{isNaN(data.totalRemainder) ? '' : FormatNumberMXN(data.totalRemainder)}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                     
                </AccordionDetails>
            </MuiAccordion>
        </>
    );
};
const mapStateToProps = state => ({
    
})

const mapDispatchToProps = (dispatch) => {
    return {
        tokenExpired: () => dispatch({ type: "TOKEN_EXPIRED" })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetailAdvance)